import { Component } from 'react';

import Popup from '../../../components/popup';
import Container from '../../../layouts/containers/container';
import Row from '../../../components/row';
import List from '../../../components/list';

import InputsText from '../../../components/inputs/inputs-text';
import InputsTextArea from '../../../components/inputs/inputs-text-area';
import InputsDropdown from '../../../components/inputs/inputs-dropdown';

import { ButtonProceed, ButtonReturn } from '../../../components/buttons';

import MeApi from '../../../lib/users/me-api';
import AdminApi from '../../../lib/admin/admin-api';
import ButtonSend from '../../../components/buttons/button-send';
import PopupContext from '../../../context/context-popup';

export default class PopupsNewMessage extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            params: {
                subject: this.props?.searchParams?.subject || null,
                body: null,
                admin_team_id: Number.parseInt(this.props?.searchParams?.adminTeamId) || window.default_admin_team_id,
            },
            errors: [],
            groups: [],
            users: [],
        }
    }

    componentDidMount() {
        this.getGroups();
    }

    confirm() {
        const { closePopup } = this.context;

        const params = { ...this.state.params };

        params.admin_team_id = Number.isInteger(params.admin_team_id) ? params.admin_team_id : params.admin_team_id?.value;

        MeApi.createConversation(params, (err) => {
            this.setState({ errors: err });
        }).then(() => {
            this.props.fetch();
            closePopup();
        });
    }

    getGroups() {
        AdminApi.getAdminGroups().then(({ data }) => {
            const options = data
                .map((key) => ({
                    label: key.name,
                    value: key.id
                }));

            this.setState({ groups: options })
        })
    }

    setParams(key, value) {
        this.setState({
            params: {
                ...this.state.params,
                [ key ]: value
            }
        })
    }

    render() {
        const { closePopup } = this.context;

        return (
            <Popup className="new-message">
                <Popup.Content>
                    <Container.Text fontSize="30px" color="white">New Message</Container.Text>

                    <List gap="20px">
                        <InputsText
                            label="Subject of your message"
                            value={this.state.params.subject}
                            onChange={e => this.setParams('subject', e.target.value)}
                            errors={this.state.errors?.subject}
                        />

                        <InputsTextArea
                            label="Message"
                            value={this.state.params.body}
                            onChange={e => this.setParams('body', e.target.value)}
                            errors={this.state.errors?.body}
                        />
                    </List>     
                </Popup.Content>

                <Popup.Buttons>
                    <Row gap="10px">
                        <ButtonSend responsive={false} onClick={this.confirm.bind(this)}>Send</ButtonSend>
                        <ButtonReturn responsive={false} onClick={closePopup}>Cancel</ButtonReturn>
                    </Row>
                </Popup.Buttons>
            </Popup>
        )
    }
}